import ArticlePage from "../Article/ArticlePage";
import MemorialArticle from "./MemorialArticle";

export default function MemorialPageDetail({ data, slug }) {
  const memorials = data.find((location) => location.slug === slug).memorials;
  // console.log(memorials[0].interior_images);

  return (
    <ArticlePage navData={data} baseRoute="locations/memorials" orderNav={false}>
      {memorials.map((entry) => (
        <MemorialArticle key={entry.id} data={entry} />
      ))}
    </ArticlePage>
  );
}
